<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col>
        <base-material-card
          color="primary"
          icon="mdi-cog"
          inline
          class="px-5 py-3 ml-0"
        >
          <template v-slot:after-heading>
            <div class="display-2 font-weight-light">
              Configurações
            </div>
          </template>
          <v-divider class="mt-10" />
          <v-expansion-panels accordion>
            <v-expansion-panel
              v-for="(modulo, i) in modulos"
              :key="i"
            >
              <v-expansion-panel-header>
                <label class="conf-header">{{ modulo.titulo }}</label>
              </v-expansion-panel-header>
              <v-expansion-panel-content
                :eager = true
              >
                <v-row class="mt-1">
                  <v-col cols="12" class="pt-0">
                  <label class="conf-describe">{{ modulo.descricao }}</label>
                  </v-col>
                </v-row>
                <v-divider class="mt-5" />
                <v-row
                  v-for="(campo, j) in modulo.campos"
                  :key="j"
                  class="mt-0"
                >
                  <v-col cols="12" class="pt-0">
                    <div v-if="campo.type == 'SELECT'">
                      <v-select
                        v-model="campo.valor"
                        :items="campo.valores_padroes"
                        :label="campo.label"
                        outlined
                        min-width="500px"
                      />
                    </div>
                    <div v-else-if="campo.type == 'INT'">
                      <validation-provider v-slot="{ errors }" rules="integer">
                        <v-text-field
                          v-model="campo.valor"
                          type="number"
                          outlined
                          :label="campo.label"
                          class="my-0"
                          min-width="500px"
                          :error-messages="errors"
                        />
                      </validation-provider>
                    </div>
                    <div v-else-if="campo.type == 'DECIMAL'">
                      <v-text-field
                        v-model="campo.valor"
                        type="number"
                        outlined
                        :label="campo.label"
                        class="my-0"
                        min-width="500px"
                        :disabled="campo.label == 'Taxa WACC (%)'"
                      /> 
                    </div>
                    <div v-else-if="campo.type == 'TEXT'">
                      <v-text-field
                        v-model="campo.valor"
                        outlined
                        :label="campo.label"
                        class="my-0"
                        min-width="500px"
                      />
                    </div>
                    <div v-else-if="campo.type == 'CHECKBOX'">
                      <v-container fluid>
                        <v-checkbox
                          v-for="(checkbox, k) in campo.valores_padroes"
                          :key="k"
                          v-model="campo.valores"
                          :label="checkbox"
                          :value="checkbox"
                          min-width="500px"
                        />
                      </v-container>
                    </div>
                    <div v-else-if="campo.type == 'DATE'">
                      <v-row justify="center">
                        <v-col cols="12" class="pt-0">
                          <date-picker
                            v-model="campo.valor"
                            :label="campo.label"
                            type="date"
                            rules="min:10"
                          />
                        </v-col>
                      </v-row>
                    </div>
                    <div v-else-if="campo.type == 'WACCTABLE'">
                      <v-row justify="center">
                        <v-col cols="12" class="pt-0">
                          <tabela-taxas-wacc 
                            ref="tabelaTaxaWaccREF"
                          />
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-btn
                    color="green darken-1"
                    :loading="loadingBtn"
                    @click="saveConfig(modulo)"
                  >
                    Salvar
                  </v-btn>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfiguracoesService from '@/services/ConfiguracoesService';
import dateFormatterMixins from '@/mixins/dateFormatterMixins';
import dayjs from 'dayjs';

export default {
  mixins: [dateFormatterMixins],

  components: {
    TabelaTaxasWacc: () => import('@/components/configuracoes/TabelaTaxasWacc.vue'),
    DatePicker: () => import("@/components/general/DatePicker.vue")
  },

  data: () => ({
    loadingBtn: false,
    modelValues: [],
    modulos: []
  }),

  mounted () {
    this.getModulos();
  },

  methods: {
    saveConfig (modulo) {
      /* JSON parse e JSON stringify irá criar uma nova copia do objeto modulo de forma profunda, nessa situação o destructuring não resolveria { ...modulo } */
      let moduloForSave = JSON.parse(JSON.stringify(modulo));
      moduloForSave = this.tratarCamposModulos(moduloForSave);

      this.loadingBtn = true;

      if(modulo.titulo == 'Parâmetros de Revisão Tarifária') {
        let taxasWacc = this.$refs.tabelaTaxaWaccREF[0].exportData();
        moduloForSave['taxa_wacc_vigentes'] = taxasWacc['taxa_wacc_vigentes'];
      }

      ConfiguracoesService.saveConfig(moduloForSave.id, moduloForSave)
        .then(resp => {
          this.$toast.success('Configurações salvas com sucesso.', '', { position: 'topRight' })
        })
        .catch(err => {
          console.log('Erro: ', err)
          this.$toast.error('Erro ao salvar configurações.', '', { position: 'topRight' })
        })
        .finally(() => this.loadingBtn = false)
    },

    formatConfigValoresPadroes (raw) {
      const obj = [];
      raw.forEach(element => {
        obj.push(element.valor);
      })
      return obj;
    },

    getModulos () {
      this.configs = []
      let obj = {}
      let objChildren = {}
      ConfiguracoesService.getModulos()
        .then(response => {
          response.data.modulos.forEach(element => {
            element.configuracoes.forEach(config => {
              if (!config.visivel) return;

              obj = {
                id: config.id,
                titulo: config.titulo,
                descricao: config.descricao,
                campos: []
              }
              config.campos.forEach(campo => {
                objChildren = {
                  id: campo.id,
                  type: campo.type,
                  label: campo.label,
                  valores_padroes: this.formatConfigValoresPadroes(campo.configuracoes_valores_padroes),
                  valor: campo.configuracoes_valores[0] ? campo.configuracoes_valores[0].valor : '',
                  // para o caso dos checkboxes
                  valores: this.formatConfigValoresPadroes(campo.configuracoes_valores)
                }

                if (objChildren.type === 'DATE' && campo.valor !== '') {
                  objChildren.valor = this.parseDate(objChildren.valor)
                }
                obj.campos.push(objChildren)
              })
              this.modulos.push(obj)
            })
          })
        })
        .catch(error => {
          console.log(error)
          this.$toast.error('Erro ao recuperar modulos.', '', { position: 'topRight' })
        })
    },

    tratarCamposModulos(modulo) {
      if (!modulo.campos) return modulo;

      modulo.campos = (modulo.campos).map(c => {

        /* Tratativa para campos 'DATE' */
        if (c.type == 'DATE') c.valor = this.formatDate(c.valor);

        /* Tratativa para campos 'DECIMAL' */
        if (c.type == 'DECIMAL') c.valor = this.preencherDuasCasasDecimais(c.valor);
        
        return c;
      });

      return modulo;
    },

    preencherDuasCasasDecimais(valor) {
      if (!valor || !valor.trim()) return valor;

      const [parteInteira, parteDecimal] = valor.split('.')
      return `${parteInteira}.${parteDecimal.padStart(2, '0')}`;
    },

    formatDate (date) {
      if (!date) return '';
        
      date = this.getOnlyDateIgnoringTimestamp(date);
      return dayjs(date).format('DD/MM/YYYY')
    },
  }
}
</script>

<style>
.conf-header {
  font-size: 13.5px;
  font-weight: bold;
}
.conf-describe {
  font-size: 13.5px;
  color: #7c7c7c;
}
</style>